import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M15.184 8.94V3.436a.837.837 0 0 0-.837-.835h-9.51A.838.838 0 0 0 4 3.435v18.4c0 .461.376.836.837.836h7.667c.045.006.093.009.141.009h6.563c.64 0 1.162-.521 1.162-1.162v-5.283c0-3.37-2.17-6.242-5.186-7.294ZM5.328 21.344V3.928h8.528v17.415H5.328Zm13.713.009h-3.857V10.367a6.404 6.404 0 0 1 3.857 5.868v5.117Z"/> <path d="M12.483 5.972h-3.75v1.329h3.75V5.972Zm0 2.418h-3.75v1.33h3.75V8.39Zm5.156 5.056H16.31v1.328h1.329v-1.328Z"/>' }
  })
);